"use client"
import { Button, Icon } from "@chakra-ui/react"
import classNames from "classnames"
import type { NavigationLinkItem } from "config/navigation/types/NavigationLinkItem"
import Link from "next/link"
import { usePathname } from "next/navigation"
import type React from "react"

export const DropdownLinkItem: React.FC<{
    item: NavigationLinkItem
    customClasses?: string
}> = ({ item, customClasses }) => {
    const pathname = usePathname()

    const handleClick = () => {
        item?.onClick && item?.onClick()
    }

    return (
        <Link href={item?.path || ""} passHref className={classNames("w-full", customClasses)}>
            <Button
                variant='nude'
                size='sm'
                borderRadius={0}
                className='w-full flex-row items-center justify-start border-0 px-4 py-2.5 text-left text-base font-normal hover:bg-gray-50 xl:flex-row xl:justify-start dark:text-gray-200 dark:hover:bg-gray-500'
                onClick={handleClick}
                leftIcon={item?.icon && <Icon as={item?.icon} className='text-xl' />}
            >
                {item?.label}
            </Button>
        </Link>
    )
}

export default DropdownLinkItem
